import {
  Button,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Checkbox,
} from '@material-ui/core';
import { AddCircle, MoreHoriz, RemoveCircle } from '@material-ui/icons';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import CreateIcon from '@material-ui/icons/Create';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import SearchIcon from '@material-ui/icons/Search';
import VisibilityIcon from '@mui/icons-material/Visibility';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  RATE_FILTERS_CREATE,
  RATE_FILTERS_EDIT,
  RATE_FILTERS_VIEW,
} from '../../../../../constants/AccomodationConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_ACCOMMODATIONS,
} from '../../../../../constants/RoleConsts';
import useOutsideAlerter from '../../../../../custom-hooks/useOutsideAlerter';
import { SaveButton } from '../../../../../shared/custom-dragdrop/Save-Button';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import CustomChip from '../../../../../shared/form-controls/custom-chip/Custom-Chip';
import ListFilterMenu from '../../../../../shared/list-filter-menu/List-Filter-Menu';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import { createDataSortMapping } from '../../../../../utils/PropertyAPIUtils';
import {
  accommodationRateFiltersActivate,
  accommodationRateFiltersDeactivate,
  deleteAccommodationRateFilterAPI,
  deleteSelectedItems,
  updateSelectedItemsStatus,
} from '../../../../../utils/ServicesAPIUtils';
import {
  allRateFiltersSelector,
  fetchAllAccommodations,
  setAllPackages,
} from '../../../../property/propertySlice';
import MultipleDeleteConfirmationPopup from '../../../../../shared/MultiActionPopUp/MultiDeleteConfirmationPopup';
import ActionMenuList from '../../../../../shared/ActionMenuList/ActionMenuList';
import {
  PARTIAL_CHECKBOX_GREEN,
  ResetFilterList,
  getCheckedIds,
  updateCheckedStatus,
  updateSelectedModule,
} from '../../../../../utils/formUtils';
import { generateConfirmationMessage } from '../../../../../utils/formUtils';
import MultipleSelectionAlert from '../../../../../shared/MultiActionPopUp/MultipleSelectionAlert';
import BulkActionCheckBox from '../../../../../shared/MultiActionPopUp/BulkActionCheckBox';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const RateFiltersList = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    selectedHotel,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
  } = props;

  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
  });
  const originalList = useSelector(allRateFiltersSelector);
  const [rateFilters, setRateFilters] = useState([]);
  const [filteredBaseList, setFilteredBaseList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterTargetButton, setFilterTargetButton] = useState(null);
  const [filterMenu, setFilterMenu] = useState([]);
  const dispatch = useDispatch();
  const wrapperRef = useRef(null);
  const searchRef = useRef(null);
  const filterRef = useRef(null);
  const prevHotelIdRef = useRef(selectedHotel);
  const [popUp, setPopUp] = useState(false);
  const [visible, setVisible] = useState(false);
  const [tempSearchText, setTempSearchText] = useState('');
  const [searchButton, setSearchButton] = useState(true);
  const [actionMenuAnchorEl, setActionMenuAnchorEl] = useState(null);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [actionMenuList, setActionMenuList] = useState([]);
  const [actionName, setActionName] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [showMultipleDeleteConfirmation, setShowMultipleDeleteConfirmation] = useState(false);
  const [showBulkActiveDeactiveConfirmation, setShowBulkActiveDeactiveConfirmation] =
    useState(false);
  const [showBulkKebabSelectionAlert, setShowBulkKebabSelectionAlert] = useState(false);
  const [showBulkSearchAlert, setShowBulkSearchAlert] = useState(false);
  const [showBulkFilterAlert, setShowBulkFilterAlert] = useState(false);
  const isFilterApplied = useRef(false);

  const resetFilterDataList = () => {
    setFilterMenu([
      {
        title: 'All',
        field: 'all',
        subMenu: [],
      },
      {
        title: 'Status',
        field: 'isActive',
        subMenu: [
          { id: 'active', name: 'Active', selected: false },
          { id: 'inactive', name: 'Inactive', selected: false },
        ],
      },
    ]);
  };
  useEffect(() => {
    // assigning data set to local list while keeping an orginal data set for filtering
    const withCheck = originalList?.map((rate) => ({
      ...rate,
      isChecked: false,
    }));
    setRateFilters(withCheck);
    setFilteredBaseList(withCheck);
    resetFilterDataList();
    setLoading(false);
    setTempSearchText('');
    setSearchButton(true);
  }, [originalList]);

  useEffect(() => {
    onsetPage(0);
    onsetRowsPerPage(5);
  }, []);

  const getCheckedRateList = rateFilters?.filter((rate) => rate?.isChecked);
  const listOfRateIds = getCheckedRateList?.map((rate) => rate?.id);
  const selectedRateLength = getCheckedRateList?.length;

  const setSearchText = (searchText) => {
    setTempSearchText(searchText);
    const checkedIdList = getCheckedIds(rateFilters, 'isChecked');
    const filteredRows = filteredBaseList.filter((item) =>
      item.name?.toLowerCase().includes(searchText.toLowerCase()),
    );
    const updatedCheckedList = updateCheckedStatus(filteredRows, checkedIdList);
    onsetPage(0);
    setRateFilters(updatedCheckedList);
  };

  useEffect(() => {
    updateSelectedModule(rateFilters, setActionMenuList, setIsAllSelected);
  }, [rateFilters]);

  useEffect(() => {
    if (loading || rateFilters?.length === 0) return;
    const totalItems = rateFilters?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [rateFilters?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== selectedHotel) {
      onsetPage(0);
    }
    prevHotelIdRef.current = selectedHotel;
  }, [selectedHotel]);

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const onOpenDrawer = (event, type) => {
    if (selectedRateLength) {
      setRateFilters(ResetFilterList);
    }
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.pack);
    handleClose();
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      pack: null,
    });
  };

  const handleContinue = (isFromFilterContinue = false) => {
    setShowBulkSearchAlert(false);
    setTempSearchText('');
    setSearchButton(true);
    setRateFilters(ResetFilterList);
    setTimeout(() => {
      if (isFromFilterContinue) {
        filterRef?.current?.click();
      } else {
        searchRef?.current?.focus();
      }
    }, 0);
  };

  const handleSearchInputFocus = (e) => {
    if (selectedRateLength) {
      searchRef?.current?.blur();
      setShowBulkSearchAlert(true);
    } else {
      setShowBulkSearchAlert(false);
    }
  };

  const handleCellMenuClick = (event, pack) => {
    event.stopPropagation();
    if (selectedRateLength > 1) {
      setShowBulkKebabSelectionAlert(true);
    } else {
      setSelectedValue({
        id: pack.id,
        name: pack.name,
        title: '',
        description: '',
        status: false,
        isActive: pack.isActive,
        anchorEl: event.currentTarget,
        pack: pack,
      });
    }
  };

  const deleteRateFilter = async (e) => {
    e.preventDefault();
    setSelectedValue((prev) => ({
      ...prev,
      title: 'Are you sure you want to delete',
      description: 'This action cannot be reversed',
      status: true,
      anchorEl: null,
    }));
  };

  const handleActivate = async () => {
    handleClose();
    const selectedLanguage = decryptLocalStorage('lang');
    const language = selectedLanguage !== 'en' ? selectedLanguage : '';
    if (selectedValue.isActive) {
      try {
        await accommodationRateFiltersDeactivate(selectedValue.id, selectedHotel, language);
        dispatch(fetchAllAccommodations(selectedHotel));
        notificationManager('success', 'Rate filter deactivated successfully');
        setSelectedValue({
          id: '',
          name: '',
          title: '',
          description: '',
          status: false,
          anchorEl: null,
          pack: null,
        });
      } catch (e) {
        notificationManager(
          'danger',
          e.graphQLErrors ? e.graphQLErrors[0].message : 'Rate filter deactivated failed',
        );
      }
    } else {
      try {
        await accommodationRateFiltersActivate(selectedValue.id, selectedHotel, language);
        dispatch(fetchAllAccommodations(selectedHotel));
        notificationManager('success', 'Rate Filter activated successfully');
        setSelectedValue({
          id: '',
          name: '',
          title: '',
          description: '',
          status: false,
          anchorEl: null,
          pack: null,
        });
      } catch (e) {
        notificationManager(
          'danger',
          e.graphQLErrors ? e.graphQLErrors[0].message : 'Rate Filter activated failed',
        );
      }
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const deleteRateFilters = async () => {
    try {
      const lang = decryptLocalStorage('lang');
      const delByLang = lang !== 'en' ? lang : '';
      if (selectedHotel && selectedValue && selectedValue.id) {
        await deleteAccommodationRateFilterAPI(selectedHotel, selectedValue.id, delByLang);
        dispatch(fetchAllAccommodations(selectedHotel));
        notificationManager('success', 'Rate Filter deleted successfully');
      }
      handleClose();
    } catch (e) {
      if (e.graphQLErrors) {
        notificationManager('danger', e.graphQLErrors[0].message);
      } else {
        notificationManager('danger', 'Failed to delete Rate Filter');
      }
      handleClose();
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const onDeleteCancel = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      pack: null,
    });
  };

  const onViewDetails = (pack, e) => {
    if (
      e.target.className === 'MuiTableCell-root MuiTableCell-body' ||
      e.target.className === 'MuiTableCell-root MuiTableCell-body MuiTableCell-alignCenter' ||
      e.target.className === 'custom-chip' ||
      e.target.className === 'MuiChip-label'
    ) {
      onViewToggle(RATE_FILTERS_VIEW, true, pack);
    }
  };

  const onClickView = (e) => {
    if (selectedValue && selectedValue.pack) {
      onViewToggle(RATE_FILTERS_VIEW, true, selectedValue.pack);
    }
  };

  const handleFilterMenu = (event) => {
    if (getCheckedRateList?.length > 0) {
      setShowBulkFilterAlert(true);
      return;
    } else {
      setFilterTargetButton(event.currentTarget);
      // setAnchorEl(event.currentTarget);
    }
  };

  const handleFilter = (filterItems, field) => {
    if (field === 'all') {
      setFilteredBaseList(originalList);
      setRateFilters(originalList);
      resetFilterDataList();
      isFilterApplied.current = false;
    } else {
      isFilterApplied.current = true;
      const activeSelected = filterItems.some((o) => o.id === 'active' && o.selected);
      const inActiveSelected = filterItems.some((o) => o.id === 'inactive' && o.selected);
      let filteredRows = [];

      if ((activeSelected && inActiveSelected) || (!activeSelected && !inActiveSelected)) {
        filteredRows = originalList;
      } else {
        if (activeSelected) {
          filteredRows = originalList.filter((item) => item.isActive === true);
        } else {
          filteredRows = originalList.filter((item) => item.isActive === false);
        }
      }
      onsetPage(0);
      setFilteredBaseList(filteredRows);
      setRateFilters(filteredRows);

      const updatedFilterMenu = [...filterMenu];
      updatedFilterMenu[updatedFilterMenu.findIndex((o) => o.field === field)].subMenu =
        filterItems;
      setFilterMenu(updatedFilterMenu);
    }
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);

  const handleActionMenuOpen = (event) => {
    setActionMenuAnchorEl(event.currentTarget);
  };

  const handleActionMenuClose = () => {
    setActionMenuAnchorEl(null);
  };

  const handleAction = (actionName) => {
    let selectedDiscount = rateFilters?.filter((item) => item?.isChecked);
    switch (actionName) {
      case 'Delete':
        if (selectedDiscount?.length > 0) {
          setShowMultipleDeleteConfirmation(true);
          setActionName('delete');
        }
        break;
      case 'Activate':
        if (selectedDiscount?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('activate');
          setIsActive(true);
        }
        break;
      case 'Deactivate':
        if (selectedDiscount?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('deactivate');
          setIsActive(false);
        }
        break;
      default:
        break;
    }
  };

  const handleCheckboxChange = (id) => {
    let actionListName = [];
    let index = rateFilters?.findIndex((item) => item.id === id);
    if (!rateFilters[index]?.isChecked) {
      rateFilters[index] = { ...rateFilters[index], isChecked: true };
    } else {
      rateFilters[index].isChecked = !rateFilters[index]?.isChecked;
    }
    setRateFilters([...rateFilters]);

    let actionList = rateFilters
      ?.filter((sInfo) => sInfo?.isChecked)
      .map((status) => status?.isActive);

    const checkedItems = rateFilters?.filter((combosList) => combosList?.isChecked);

    if (checkedItems.length === 0) {
      setActionMenuList([]);
      setIsAllSelected(false);
      return;
    }

    const isActiveSelected = actionList.includes(true);
    const isInactiveSelected = actionList.includes(false);

    if (isActiveSelected && isInactiveSelected) {
      actionListName.push('Activate', 'Deactivate');
    } else if (isActiveSelected) {
      actionListName.push('Deactivate');
    } else if (isInactiveSelected) {
      actionListName.push('Activate');
    }

    const isAllSelected = rateFilters?.every((item) => item?.isChecked);
    setIsAllSelected(isAllSelected);
    if (!rateFilters[index].isChecked && !actionList?.some((item) => item?.isChecked)) {
      setActionMenuList([]);
    }
    setActionMenuList(actionListName);
  };

  const handleSelectAll = (event) => {
    let selectedMenuList = [];
    let actionListName = [];
    const CheckedValue = event?.target?.checked;
    setIsAllSelected(CheckedValue);
    selectedMenuList = rateFilters?.map((item) => {
      return {
        ...item,
        isChecked: CheckedValue,
      };
    });

    const isActive = selectedMenuList?.some((Rate_filter) => Rate_filter?.isActive);
    const isInactive = selectedMenuList?.some((Rate_filter) => !Rate_filter.isActive);

    if (isActive && !actionListName?.includes('Deactivate')) {
      actionListName.push('Deactivate');
    }
    if (isInactive && !actionListName?.includes('Activate')) {
      actionListName.push('Activate');
    }
    setRateFilters([...selectedMenuList]);

    const sortActionMenuList = actionListName.sort((a, b) => {
      const order = { Activate: 1, Deactivate: 2, Delete: 3 };
      return order[a] - order[b];
    });

    setActionMenuList(sortActionMenuList);

    if (!event?.target?.checked && !selectedMenuList?.some((item) => item?.isChecked)) {
      setActionMenuList([]);
    }
  };

  const onApiCallConfirmationNotification = generateConfirmationMessage(
    'Rate Filter',
    listOfRateIds?.length,
    isActive,
  );

  const handleMultipleStatusChange = async () => {
    handleClose();
    setActionMenuList([]);
    try {
      dispatch(stepUpLoaderCount());
      setLoading(true);
      const filterApplied = tempSearchText?.length > 0 || isFilterApplied?.current ? true : false;
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'ACCOMMODATION_RATE_FILTER';
      await updateSelectedItemsStatus(
        listOfRateIds,
        selectedHotel,
        selectedLang,
        moduleName,
        '',
        isActive,
        filterApplied ? false : isAllSelected,
      );
      dispatch(fetchAllAccommodations(selectedHotel));
      notificationManager('success', onApiCallConfirmationNotification);
      setSelectedValue({
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        activate: false,
        brand: null,
      });
      setLoading(false);
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors
          ? e.graphQLErrors[0].message
          : 'The status of the Rate Filter was not changed',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setRateFilters(ResetFilterList);
    setIsAllSelected(false);
  };

  const deleteMultipleSelection = async () => {
    handleClose();
    try {
      setLoading(true);
      const filterApplied = tempSearchText.length > 0 || isFilterApplied?.current ? true : false;
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'ACCOMMODATION_RATE_FILTER';
      await deleteSelectedItems(
        listOfRateIds,
        selectedHotel,
        selectedLang,
        moduleName,
        '',
        filterApplied ? false : isAllSelected,
      );
      dispatch(fetchAllAccommodations(selectedHotel));
      notificationManager('success', 'Rate Filter deleted successfully');
      setSelectedValue({
        ...selectedValue,
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        brand: null,
      });
      setLoading(false);
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Failed to delete Rate Filter',
      );
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  return (
    <div className='mt-4 mb-4 group-list-container'>
      {selectedValue.id && selectedValue.status === true && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={deleteRateFilters}
          onDeleteCancel={onDeleteCancel}
        />
      )}
      <div className='row mx-2 d-flex'>
        <div className='col-12 col-lg-4'>
          {rateFilters && (
            <TextField
              inputRef={searchRef}
              focused={false}
              className='w-100'
              onChange={(e) => {
                setSearchText(e.target.value);
                setSearchButton(e?.target?.value ? false : true);
              }}
              onFocus={(e) => handleSearchInputFocus(e)}
              label='Search'
              value={tempSearchText}
              InputProps={
                searchButton && {
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton className='showpopup'>
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }
              }
            />
          )}
        </div>
        <div className='col-12 col-lg-8 pt-3 pt-lg-0 d-flex justify-content-end gap-2'>
          {actionMenuList?.length !== 0 && (
            <div>
              <Button
                onClick={handleActionMenuOpen}
                variant='outlined'
                size='large'
                className='showpopup'
                endIcon={<ArrowDropDownIcon />}
              >
                Actions
              </Button>
              <ActionMenuList
                anchorEl={actionMenuAnchorEl ?? null}
                handleClose={handleActionMenuClose}
                handleAction={handleAction}
                actionMenuItems={actionMenuList}
              />
            </div>
          )}
          <SaveButton
            visible={visible}
            setVisible={setVisible}
            popUp={popUp}
            setPopUp={setPopUp}
            placeHolder={rateFilters}
            setPlaceHolder={setRateFilters}
            globalPlaceHolder={originalList}
            setGlobalPlaceHolder={setAllPackages}
            dispatch={dispatch}
            mappingApi={createDataSortMapping}
            displayText='Accommodations package'
            module='ACCOMMODATION_RATE_FILTERS'
          />
          {rateFilters && (
            <>
              <Button
                innerRef={filterRef}
                variant='outlined'
                color='secondary'
                size='large'
                endIcon={<ArrowDropDownIcon />}
                onClick={(e) => {
                  handleFilterMenu(e);
                }}
                className={
                  filterMenu?.some((f) => f?.subMenu?.some((s) => s?.selected))
                    ? 'filterButton'
                    : 'showpopup'
                }
              >
                Filter
              </Button>
              <ListFilterMenu
                menu={filterMenu}
                targetEl={filterTargetButton}
                handleFilterClose={() => setFilterTargetButton(null)}
                handleFilter={(items, field) => {
                  handleFilter(items, field);
                }}
                hideSearch={true}
              />
            </>
          )}
          {permissions[RBAC_TYPE_HOTEL_ACCOMMODATIONS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
            <Button
              variant='contained'
              color='primary'
              size='large'
              startIcon={<AddCircle />}
              onClick={(e) => {
                onOpenDrawer(e, RATE_FILTERS_CREATE);
              }}
              className='showpopup'
            >
              Add Rate Filter
            </Button>
          )}
        </div>
      </div>

      <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
        {loading ? (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        ) : (
          rateFilters && (
            <TableContainer>
              <Table className='list-table' aria-label='simple table'>
                <TableHead>
                  <TableRow>
                    <TableCell className='w-5 ps-5' align='right'>
                      <BulkActionCheckBox
                        onChange={handleSelectAll}
                        checked={isAllSelected || false}
                        selectedLength={selectedRateLength}
                        totalLength={originalList?.length}
                        inputProps={{
                          'aria-label': 'select all Rate Filters',
                        }}
                        className={PARTIAL_CHECKBOX_GREEN}
                      />
                    </TableCell>
                    <TableCell className='w-20'>Rate Filter Name</TableCell>
                    <TableCell className='w-20'>Code</TableCell>
                    <TableCell className='w-40'>Rate Codes</TableCell>
                    <TableCell align='center' className='w-30'>
                      Status
                    </TableCell>
                    <TableCell align='right'></TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {(rowsPerPage > 0
                    ? rateFilters.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    : rateFilters
                  ).map((item, i) => (
                    <TableRow
                      key={i}
                      className='border-white pointer'
                      onClick={(e) => {
                        onViewDetails(item, e);
                      }}
                    >
                      <TableCell className='ps-5'>
                        <Checkbox
                          onChange={(event) => handleCheckboxChange(item?.id)}
                          checked={item?.isChecked || false}
                          inputProps={{
                            'aria-label': `select rateFilters ${item?.id}`,
                          }}
                        />
                      </TableCell>
                      <TableCell>{item?.name}</TableCell>
                      <TableCell>{item?.code}</TableCell>
                      <TableCell>{item?.rateCodes || '---'}</TableCell>
                      <TableCell align='center'>
                        <CustomChip
                          label={item?.isActive ? 'Active' : 'Inactive'}
                          color={item?.isActive ? 'primary' : 'default'}
                        />
                      </TableCell>
                      <TableCell align='right'>
                        {permissions[RBAC_TYPE_HOTEL_ACCOMMODATIONS] ===
                          RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                          <Button
                            aria-controls='simple-menu'
                            aria-haspopup='true'
                            onClick={(e) => {
                              handleCellMenuClick(e, item);
                            }}
                            className='showpopupInner'
                          >
                            <MoreHoriz className='showpopupInner' />
                          </Button>
                        )}
                        <Menu
                          id={i}
                          anchorEl={selectedValue?.anchorEl}
                          disableRestoreFocus
                          MenuListProps={{ autoFocusItem: false }}
                          keepMounted
                          open={Boolean(selectedValue.anchorEl) && selectedValue.id === item.id}
                          onClose={handleClose}
                          className='shadow'
                        >
                          <MenuItem
                            className='pe-4'
                            onClick={(e) => {
                              handleActivate();
                            }}
                          >
                            {selectedValue.isActive === true ? (
                              <>
                                <RemoveCircle className='me-2 action-menu-icon' />
                                Deactivate
                              </>
                            ) : (
                              <>
                                <AddCircle className='me-2 action-menu-icon' />
                                Activate
                              </>
                            )}
                          </MenuItem>
                          <MenuItem
                            className='pe-4'
                            onClick={(e) => {
                              onOpenDrawer(e, RATE_FILTERS_EDIT);
                            }}
                          >
                            <CreateIcon className='me-2 action-menu-icon' />
                            Edit
                          </MenuItem>
                          <MenuItem
                            className='pe-4'
                            onClick={(e) => {
                              onClickView(e);
                            }}
                          >
                            <VisibilityIcon className='me-2 action-menu-icon' />
                            View
                          </MenuItem>
                          <MenuItem
                            className='pe-4'
                            onClick={(e) => {
                              deleteRateFilter(e);
                            }}
                          >
                            <DeleteForeverIcon className='me-2 action-menu-icon' />
                            Delete
                          </MenuItem>
                        </Menu>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>

                <TableFooter>
                  <TableRow className='paginator'>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                      count={rateFilters.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: { 'aria-label': 'rows per page' },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )
        )}{' '}
        {showMultipleDeleteConfirmation && (
          <MultipleDeleteConfirmationPopup
            title={`Are you sure you want to ${actionName} this selection?`}
            subTitle={`A selection of ${selectedRateLength} ${
              selectedRateLength > 1 ? 'Rate filters' : 'Rate filter'
            } will be ${actionName}d. This Action is irreversible.`}
            isOpen={showMultipleDeleteConfirmation}
            onClose={() => setShowMultipleDeleteConfirmation(false)}
            onConfirm={() => {
              deleteMultipleSelection();
            }}
            leftButtonName={'Cancel'}
            rightButtonName={'Delete'}
          />
        )}
        {showBulkActiveDeactiveConfirmation && (
          <MultipleDeleteConfirmationPopup
            title={`Are you sure you want to ${actionName} this selection?`}
            subTitle={`A selection of ${selectedRateLength}  ${
              selectedRateLength > 1 ? 'Rate filters' : 'Rate filter'
            } will be ${actionName}d.`}
            isOpen={showBulkActiveDeactiveConfirmation}
            onClose={() => setShowBulkActiveDeactiveConfirmation(false)}
            onConfirm={() => {
              handleMultipleStatusChange();
            }}
            leftButtonName={'No'}
            rightButtonName={'Yes'}
          />
        )}
        {showBulkSearchAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkSearchAlert}
            message="If you perform a search after making selections, the items you've selected will be lost."
            leftButtonName='Cancel'
            rightButtonName='Continue'
            onClose={() => setShowBulkSearchAlert(false)}
            onConfirm={handleContinue}
          />
        )}
        {showBulkKebabSelectionAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkKebabSelectionAlert}
            onClose={() => setShowBulkKebabSelectionAlert(false)}
            message='Please select one item from the list that you want to edit.'
            centerButtonName='OK'
          />
        )}
        {showBulkFilterAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkFilterAlert}
            onClose={() => setShowBulkFilterAlert(false)}
            message="If you perform a filter after making selections, the items you've selected will be lost."
            leftButtonName='Cancel'
            rightButtonName='Continue'
            onConfirm={() => {
              handleContinue(true);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default RateFiltersList;
